export default "__VITE_ASSET__ed6f4088__$_?component__"